import React from 'react'
import { ActivityHistoryRowType } from '../activityHistoryTypes'
import { t, Trans } from '@lingui/macro'
import {
  checkIsCPDEvidence,
  checkIsTopic,
  getActivityFormattedDate
} from '../activityHistoryUtils'
import { TooltipHelpInfo } from '../../../components/common/tooltip/TooltipHelp'
import { Box } from 'front-end/src/components'

type ActivityStatusInfoProps = ActivityHistoryRowType

const ActivityStatusInfo = (props: ActivityStatusInfoProps) => {
  if (checkIsTopic(props) && props.sharedBy) {
    const sharedBy = t`Shared by: ${props.sharedBy.display_name}`
    const sharedOn = t`Shared on: ${getActivityFormattedDate(
      props?.share_batch_ts
    )}`

    return (
      <TooltipHelpInfo isBlock>
        <Box>{sharedBy}</Box>
        <Box>{sharedOn}</Box>
      </TooltipHelpInfo>
    )
  }

  if (checkIsCPDEvidence(props)) {
    return (
      <TooltipHelpInfo isBlock>
        <Trans>
          First uploaded on: {getActivityFormattedDate(props.created_at)}
        </Trans>
      </TooltipHelpInfo>
    )
  }

  return null
}

export default ActivityStatusInfo
